import { FormControl } from '@angular/forms';
import { ModelAndSerialNumberFieldset } from '../../models/appliance-details-stepped/model-and-serial-number-fieldset.interface';

export const mockModelAndSerialNumberFieldset: ModelAndSerialNumberFieldset = {
  modelNumber: new FormControl(null),
  serialNumber: new FormControl(null),
};
